import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { View } from 'react-native';
import type { UseMutateFunction } from 'react-query';

import styles from './feedback-dialog-content.style';
import FeedbackIconButton from './feedback-icon-button';
import { isBigScreen } from '../../../components/media-query';
import ThemedText2 from '../../themed-text-2';
import FeedbackActions from '../components/feedback-actions';
import FeedbackForm from '../components/feedback-form';

interface FeedbackDialogContentProps {
  nlsKeys: {
    title: string;
    instructions: string;
    enterText: string;
  };
  isLoading: boolean;
  onClose: () => void;
  onSubmit: UseMutateFunction<Response, unknown, string, unknown>;
}

export default function FeedbackDialogContent({
  nlsKeys,
  isLoading,
  onClose,
  onSubmit,
}: FeedbackDialogContentProps) {
  const [message, setMessage] = useState('');
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <View style={styles.title}>
        <ThemedText2 fontSize={20} fontWeightStyle="bold">
          {t(nlsKeys.title)}
        </ThemedText2>
        {isBigScreen() && (
          <FeedbackIconButton
            iconName="times"
            iconSize={16}
            onPress={onClose}
          />
        )}
      </View>
      <FeedbackForm
        nlsKeys={nlsKeys}
        value={message}
        onChangeText={setMessage}
      />
      <FeedbackActions
        disabled={!message.trim()}
        isLoading={isLoading}
        onClose={onClose}
        onSubmit={() => onSubmit(message)}
      />
    </View>
  );
}
